import React from 'react'
import { observer } from "mobx-react";
import { Container, Tab, Tabs } from '@material-ui/core';
import { useStores } from "src/stores/rootStore";
import { Quarter } from 'src/stores/models/enums';
import { Skeleton } from '@material-ui/lab';
import { IntroJoy } from './react-intro';


export const QARFormQuarters = observer(() => {

    const { qarFormStore, userStore } = useStores();

    const renderQuarters = () => {
        if (!qarFormStore.selectedQuarterId) {
            return (
                <Container>
                    <Skeleton variant="text" width="80%" style={{ margin: "0px 0", display: "inline-block" }} />
                </Container>
            );
        }

        return (
            <>
                <IntroJoy store={qarFormStore}></IntroJoy>
                <Tabs value={qarFormStore.selectedQuarterId}
                    onChange={async(_, value) => {
                        await qarFormStore.saveQarData(qarFormStore.selectedQuarterId!, userStore.currentUserID)

                        qarFormStore.selectedQuarterId = value;

                        await qarFormStore.loadFormData(userStore.currentUserID, value);
                    }}
                    className="MuiPaper-rounded quarter" variant="scrollable" scrollButtons="auto"
                    style={{ padding: "0px 0px 10px 0px" }}
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#4183C4",
                        },
                    }}
                >
                    {qarFormStore.quarters?.map((x) => (
                        <Tab
                            key={x.managerReviewAdminId} value={x.managerReviewAdminId}
                            label={Quarter[x.quarter] + "/" + x.quarterYear}
                        />
                    ))}
                </Tabs>
            </>
        );
    }

    return (
        <>
            {renderQuarters()}
        </>
    );

});